import React from "react";
import { Carousel } from "react-responsive-carousel";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import './SliderImage.css'

const SliderImage = ({ data }) => {
  return (
    <>
      <Carousel
        height="500px"
        autoPlay={true}
        infiniteLoop={true}
        interval={3000}
      >
        {data &&
          data.map((item, index) => (
            <div key={item} style={{ height: "100%" }} >
              <img style={{ objectFit: "contain", height: "100%" }} src={item.image} alt="" />
            </div>
          ))}
      </Carousel>
    </>
  );
};

export default SliderImage;
